import React from 'react';

const whatsappUrl = 'https://wa.link/u4vxgs?text=Hi%2C%20I%20want%20to%20start%20a%20project%20with%20Vionex%20Labs';

const FloatingWhatsAppButton = () => (
  <a
    href={whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: 'fixed',
      bottom: '28px',
      right: '28px',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textDecoration: 'none',
      transition: 'box-shadow 0.2s, transform 0.2s',
      padding: '10px 20px 10px 14px',
      borderRadius: '22px',
      background: 'rgba(255,255,255,0.9)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      border: '1px solid rgba(255,255,255,0.24)',
      cursor: 'pointer',
      gap: '10px',
      minWidth: 'fit-content',
    }}
    className="floating-whatsapp-btn"
    aria-label="WhatsApp Now"
  >
    <svg width="26" height="26" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:'block', flexShrink: 0}}>
      <circle cx="16" cy="16" r="16" fill="#25D366"/>
      <path d="M23.472 19.339c-.355-.177-2.096-1.034-2.42-1.153-.324-.118-.56-.177-.797.178-.237.355-.914 1.153-1.12 1.39-.207.237-.412.266-.767.089-.355-.178-1.5-.553-2.86-1.763-1.057-.944-1.77-2.108-1.98-2.463-.207-.355-.022-.546.155-.723.159-.158.355-.412.533-.62.178-.207.237-.355.355-.59.118-.237.06-.443-.03-.62-.089-.178-.797-1.92-1.09-2.63-.287-.69-.58-.595-.797-.606-.207-.009-.443-.011-.68-.011-.237 0-.62.089-.944.443-.324.355-1.24 1.21-1.24 2.95 0 1.74 1.267 3.422 1.444 3.66.178.237 2.5 3.82 6.06 5.207.847.292 1.507.466 2.022.596.849.203 1.624.174 2.236.106.682-.075 2.096-.857 2.393-1.687.296-.83.296-1.54.207-1.687-.089-.148-.324-.237-.68-.414z" fill="#fff"/>
    </svg>
    <span
      style={{
        color: '#25D366',
        fontWeight: 300,
        fontSize: '15px',
        background: 'transparent',
        padding: 0,
        margin: 0,
        boxShadow: 'none',
        whiteSpace: 'nowrap',
        letterSpacing: 0.2,
      }}
      className="floating-whatsapp-label"
    >
      WhatsApp Now
    </span>
    <style>{`
      .floating-whatsapp-btn:hover {
        box-shadow: 0 12px 32px 0 rgba(31, 38, 135, 0.22);
        transform: scale(1.08);
      }
    `}</style>
  </a>
);

export default FloatingWhatsAppButton; 